import { SelectOption } from '../components/form/SelectInput';

export const sortSimpleObjectArray = (
  array: object[],
  propertyName: string,
  sortOrder: 'ASC' | 'DESC' = 'ASC'
): object[] => {
  return array.sort((a: any, b: any) => {
    const first = sortOrder === 'ASC' ? a : b;
    const second = sortOrder === 'ASC' ? b : a;

    const firstVal = first[propertyName];
    const secondVal = second[propertyName];

    if (typeof firstVal === 'string') {
      return firstVal.localeCompare(secondVal, undefined, { numeric: true });
    } else if (typeof firstVal === 'number') {
      return firstVal - secondVal;
    }

    return 0;
  });
};

export const generateSelectOptions = (
  options: any[],
  paramToUseForName: string,
  paramToUseForValue: string
): SelectOption[] => {
  return options
    ? options.map(opt => {
        const selectOption = { name: opt[paramToUseForName], value: opt[paramToUseForValue] };
        return selectOption;
      })
    : [];
};


// required for cloning nested objects
export const objectDeepClone = (input: any) => {
  if (input === null || input === undefined || typeof input !== 'object') {
    return input;
  }

  const initialOutput = Array.isArray(input) ? [] : {};

  return Object.keys(input).reduce((acc: any, key: any) => {
    acc[key] = objectDeepClone(input[key]);
    return acc;
  }, initialOutput);
};

export const toBoolean = (value: boolean | string | undefined) => {
  if (value === undefined) return undefined;
  if (typeof value === 'string') return value.toLowerCase() === 'true';
  return value;
};
